exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.img_bonus[data-v-b1d08e12] {\n\theight: 90px !important;\n}\n", ""]);

// exports
